import { DefaultButton } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface ErrorPageProps {
    title: string;
    message: string | string[];
    autoRedirectIfNextExists: boolean
}

const ErrorPage: React.FC<ErrorPageProps> = ({ title, message, autoRedirectIfNextExists }) => {
    const [showButton, setShowButton] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        // nextパラメータが存在する場合は自動リダイレクト
        if (autoRedirectIfNextExists) {
            const searchParams = new URLSearchParams(window.location.search);
            const nextUrl = searchParams.get('next');
            
            if (nextUrl) {
                handleLoginRedirect()
            }
        }


        const companyKey = localStorage.getItem('WorQuforGAI_companykey');
        if (companyKey) {
            setShowButton(true);
        }
    }, []);

    const handleLoginRedirect = () => {
        const companyKey = localStorage.getItem('WorQuforGAI_companykey');
        if (companyKey) {
            const queryString = window.location.search;
            navigate(`/login/${companyKey}${queryString}`)
        }
    };

    return (
        <div style={{
            textAlign: "center",
            verticalAlign: "middle",
            background: "#f2f2f2",
            fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            minHeight: "100vh",
            padding: "23px 0 0 0",
            margin: 0
        }}>
            <h2 style={{ fontSize: "28px", marginBottom: "5px", marginTop: 0 }}>WorQu for GAI</h2>
            <h3 style={{ fontSize: "1rem", marginTop: 0 }}>powered by ChatGPT</h3>
            <div style={{
                maxWidth: "350px",
                margin: "0 auto",
                padding: "30px 10px",
                backgroundColor: "#ffffff",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxShadow: "0 2px 4px #00000024, 0 0 2px #0000001f"
            }}>
                <p style={{
                    fontSize: "1.4rem",
                    fontWeight: 800,
                    color: "#58535E"
                }}>{title}</p>
                {Array.isArray(message) ? (
                    message.map((msg, index) => (
                        <p key={index} style={{
                            fontSize: "0.8rem",
                            fontWeight: 400,
                            textAlign: "left"
                        }}>{msg}</p>
                    ))
                ) : (
                    <p style={{
                        fontSize: "0.8rem",
                        fontWeight: 400,
                        textAlign: "left"
                    }}>{message}</p>
                )}
                {showButton && (
                    <DefaultButton onClick={handleLoginRedirect}>
                        ログイン画面
                    </DefaultButton>
                )}
            </div>
        </div>
    );
};

// 個別コンポーネント
export const InvalidIpPage = () => (
    <ErrorPage 
        title="指定外IP" 
        message="指定外のIPアドレスからアクセスされました。" 
        autoRedirectIfNextExists={false}
    />
);

export const MultiDeviceNoticePage = () => (
    <ErrorPage 
        title="複数ログイン" 
        message={[
            "他デバイスからログインされたため、ログアウトしました。",
            "お手数ですがログイン画面から再度アクセスしてください。"
        ]} 
        autoRedirectIfNextExists={false}
    />
);

export const BadRoutePage = () => (
    <ErrorPage 
        title="不正アクセス" 
        message={[
            "ログイン情報を取得できません。",
            "お手数ですがログイン画面から再度アクセスしてください。"
        ]} 
        autoRedirectIfNextExists={true}
    />
);

export const SessionTimeoutPage = () => (
    <ErrorPage 
        title="タイムアウト" 
        message={[
            "一定時間操作がなかったため、ログアウトしました。",
            "お手数ですがログイン画面から再度アクセスしてください。"
        ]} 
        autoRedirectIfNextExists={false}
    />
);

export const NotFoundPage = () => (
    <ErrorPage 
        title="404 NotFound" 
        message={[
            "ページが見つかりませんでした。"
        ]} 
        autoRedirectIfNextExists={false}
    />
);